import React from "react";
import { Typography, Box, styled, Link } from "@mui/material";
import PhoneInput from "react-phone-number-input";
import { Link as RouterLink } from "react-router-dom";
import "react-phone-number-input/style.css";

const StyledPhoneInputContainer = styled("div")({
  "& .PhoneInput": {
    display: "flex",
    alignItems: "center",
  },
  "& .PhoneInputInput": {
    fontFamily: '"Unbounded", "Arial", sans-serif',
    width: "100%",
    height: "56px",
    fontSize: "16px",
    borderRadius: "8px",
    backgroundColor: "#1C1C1E",
    border: "1px solid #38383A",
    padding: "0 12px",
    outline: "none",
    color: "#FFFFFF",
    "&:focus": {
      borderColor: "#1976d2",
      borderWidth: "2px",
    },
  },
  "& .PhoneInputCountry": {
    marginRight: "8px",
    padding: "8px",
    backgroundColor: "#1C1C1E",
    borderRadius: "8px",
  },
  "& .PhoneInputCountrySelect": {
    fontFamily: '"Unbounded", "Arial", sans-serif',
    fontSize: "16px",
    color: "#FFFFFF",
  },
});

const PhoneNumberInput = ({
  value,
  onChange,
  required = true,
  label = "Phone number",
  placeholder = "Enter phone number",
  country,
  onCountryChange,
}) => {
  return (
    <>
      <Typography
        sx={{
          mb: 1,
          color: "#FFFFFF",
          fontWeight: 500,
        }}
      >
        {label}{" "}
        {required && (
          <Box component="span" sx={{ color: "error.main" }}>
            *
          </Box>
        )}
      </Typography>
      <StyledPhoneInputContainer
        sx={{
          mb: 3,
        }}
      >
        <PhoneInput
          international={true}
          countryCallingCodeEditable={false}
          country={country}
          defaultCountry="US"
          value={value}
          onChange={onChange}
          onCountryChange={onCountryChange}
          placeholder={placeholder}
          countrySelectProps={{
            search: true,
            searchPlaceholder: "Search countries...",
          }}
        />
      </StyledPhoneInputContainer>
    </>
  );
};

export default PhoneNumberInput;
